import type { CSSProperties } from 'react';
import { ICONS, type IconName } from './icons.tsx';
import { devWarn } from '../../lib/devLog.js';

type IconSize = 16 | 18 | 20 | 24 | 48;
type IconTone = 'default' | 'muted' | 'primary' | 'danger' | 'success' | 'warning';

interface AppIconProps {
  name: IconName;
  size?: IconSize;
  tone?: IconTone;
  className?: string;
  style?: CSSProperties;
  'aria-label'?: string;
}

const toneColors: Record<IconTone, string> = {
  default: 'var(--color-text-primary)',
  muted: 'var(--color-text-muted)',
  primary: 'var(--color-primary)',
  danger: 'var(--color-danger)',
  success: 'var(--color-success)',
  warning: 'var(--color-warning)',
};

export function AppIcon({
  name,
  size = 20,
  tone = 'default',
  className,
  style,
  'aria-label': ariaLabel,
}: AppIconProps) {
  const IconComponent = ICONS[name];

  if (!IconComponent) {
    devWarn(`AppIcon: Icon "${name}" not found`);
    return null;
  }

  const iconStyle: CSSProperties = {
    color: toneColors[tone],
    flexShrink: 0,
  };

  return (
    <IconComponent
      size={size}
      style={{ ...iconStyle, ...style }}
      className={className}
      aria-label={ariaLabel}
    />
  );
}
